import { z } from 'zod';

export const Rs485SensorModelSchema = z.enum(['mlx90614', 'mfrc522', 'hx711', 'adc_loop', 'vl53']);

export const HxUnitsSchema = z.enum(['raw', 'grams', 'newtons']);
export const AdcUnitsSchema = z.enum(['raw', 'volts_x1000', 'ma_x100', 'user']);

const baseReading = { slave_id: z.number().int().min(1).max(247) };

export const Rs485SensorReadingSchema = z.discriminatedUnion('model', [
  z.object({
    model: z.literal('mlx90614'),
    ...baseReading,
    ambient_c: z.number(),
    object_c: z.number(),
    age_ms: z.number().int().nonnegative(),
  }),
  z.object({
    model: z.literal('mfrc522'),
    ...baseReading,
    uid: z.number().int().nonnegative(),
    uid_len: z.number().int().min(0).max(7),
    scan_count: z.number().int().nonnegative(),
    present: z.boolean(),
  }),
  z.object({
    model: z.literal('hx711'),
    ...baseReading,
    weight: z.number().int(),
    units: HxUnitsSchema,
    age_ms: z.number().int().nonnegative(),
  }),
  z.object({
    model: z.literal('adc_loop'),
    ...baseReading,
    raw: z.number().int().min(0).max(65535),
    engineering: z.number(),
    units: AdcUnitsSchema,
    age_ms: z.number().int().nonnegative(),
  }),
  z.object({
    model: z.literal('vl53'),
    ...baseReading,
    // null when the chip reported no target (out of range / no return).
    range_mm: z.number().int().min(0).max(65535).nullable(),
    range_status: z.number().int().min(0).max(65535),
    signal_rate_x256: z.number().int().min(0).max(65535),
    age_ms: z.number().int().nonnegative(),
  }),
]);

export type ParsedRs485SensorModel = z.infer<typeof Rs485SensorModelSchema>;
export type ParsedRs485SensorReading = z.infer<typeof Rs485SensorReadingSchema>;
export type ParsedHxUnits = z.infer<typeof HxUnitsSchema>;
export type ParsedAdcUnits = z.infer<typeof AdcUnitsSchema>;
